<template>
  <transition name="fade">
    <div class="media notification">
      <div class="media-left">
        <i class="material-icons icon is-large">{{ icon }}</i>
      </div>
      <div class="media-content">
        <p class="title" :class="className">{{ type || 'info' }}</p>
        <p class="text" v-html="text"></p>
        <button class="delete" @click="remove"></button>
      </div>
    </div>
  </transition>
</template>

<script>
import icons from 'config/icons';
import notifications from 'services/Notifications';

export default {
  props: {
    item: Object,
  },

  computed: {
    type() {
      return this.item.type || 'info';
    },

    text() {
      return this.item.text;
    },

    icon() {
      return icons.notifications[this.type] || 'info';
    },

    className() {
      return 'is-' + this.type;
    },
  },

  methods: {
    remove() {
      notifications.remove(this.item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';
@import '~scss/utilities/mixins.scss';

.notification {
  position: relative;
  max-width: 800px;
  margin: 10px auto;
  border: 0;
  padding: 0;
  background-color: white;
  box-shadow: 0 10px 30px rgba(black, 0.3);
  pointer-events: auto;

  .title {
    margin-bottom: 0;
  }
}

.media-content {
  padding-top: 0.5rem;
}

.icon {
  width: 56px;
  height: 56px;
  background: $grey-lighter;
  color: black;
}

.title {
  margin: 0 0 1px 0;
  font-size: 12px;
  font-weight: 500;
  color: $grey;
  font-variant: small-caps;
}

.text {
  color: black;
}

button {
  position: absolute;
  top: 0;
  right: 0;
  margin: 18px;
  background: $grey-lighter;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
